type SpinnerSize = 'sm' | 'md';

type SpinnerType = 'border' | 'grow';

interface SpinnerProps {
    size?: SpinnerSize;
    type?: SpinnerType;
    colorSheme?: string;
}

export const Spinner = (props: SpinnerProps) => {
    const spinnerType = props.type ?? 'border';
    const typeClass =
        spinnerType === 'border' ? 'spinner-border' : 'spinner-grow';
    const spinnerSize = props.size ?? 'md';
    const sizeClass = spinnerSize === 'md' ? '' : `${typeClass}-sm`;
    const colorSheme = props.colorSheme ?? 'secondary';
    const colorClass = `text-${colorSheme}`;
    const spinnerClassName = `${typeClass} ${sizeClass} ${colorClass}`;
    return (
        <div className={spinnerClassName} role="status">
            <span className='vb-visually-hidden'>Loading...</span>
        </div>
    );
};
